import React from 'react';

import FilterBuilder, { ADVANCED_NOTE } from '../common/FilterBuilder';

export { ADVANCED_NOTE };

/** The items subject's copy for the shared builder. */
export const ITEM_FILTER_EMPTY_TEXT = 'No conditions yet — every item in this collection is shown.';
export const ITEM_FILTER_PLACEHOLDER = 'card = progress-note and created > -3mo';
/** The items page's `/` shortcut clicks this id. */
export const ITEM_FILTER_TRIGGER_ID = 'items-filter-trigger';

/**
 * The shared FilterBuilder with the items-page defaults. Every existing import
 * keeps working; pass any of the copy props to override.
 */
export default function ItemFilterBuilder(props) {
	return (
		<FilterBuilder
			emptyText={ITEM_FILTER_EMPTY_TEXT}
			placeholder={ITEM_FILTER_PLACEHOLDER}
			triggerId={ITEM_FILTER_TRIGGER_ID}
			{...props}
		/>
	);
}
